import axios from 'axios';

// Use the same domain as your website, not localhost
const API_URL = '/api';

class AnalyticsService {
  static async getAnalyticsData() {
    try {
      const response = await axios.get(`${API_URL}/analytics/analytics-data`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      throw error;
    }
  }

  static async getStats() {
    try {
      const response = await axios.get(`${API_URL}/analytics/stats`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      throw error;
    }
  }
}

export default AnalyticsService;
